module.exports = __webpack_public_path__ + "img/CtrlRoom_music_2.89aa713b.png";